import { render, staticRenderFns } from "./PgaCardFieldGroup.vue?vue&type=template&id=b91a7d82&"
import script from "./PgaCardFieldGroup.vue?vue&type=script&lang=ts&"
export * from "./PgaCardFieldGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText,VCardTitle})


/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b91a7d82')) {
      api.createRecord('b91a7d82', component.options)
    } else {
      api.reload('b91a7d82', component.options)
    }
    module.hot.accept("./PgaCardFieldGroup.vue?vue&type=template&id=b91a7d82&", function () {
      api.rerender('b91a7d82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PgaCardFieldGroup.vue"
export default component.exports